export const COMPANY_CREATED = "company.created" as const;
export const CONTACT_CREATED = "contact.created" as const;
export const CONTACT_NOTE_CREATED = "contactNote.created" as const;
export const DEAL_CREATED = "deal.created" as const;
export const DEAL_NOTE_CREATED = "dealNote.created" as const;
